// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { CampaignOutlined,ManageAccountsOutlined,PeopleAltOutlined, SettingsInputComponentOutlined,TableChartOutlined,BuildOutlined, DashboardOutlined,LanguageOutlined,CurrencyExchangeOutlined,SettingsOutlined,SettingsSuggestOutlined, FactCheckOutlined, LocalOfferOutlined, WidgetsOutlined, MonetizationOnOutlined, VerifiedOutlined, AssignmentTurnedInOutlined, TrackChangesOutlined, AutoModeOutlined, WorkspacesOutlined, DisplaySettingsOutlined, BusinessCenterOutlined, Insights, PeopleOutlined, BusinessOutlined, PersonOutlineOutlined, AutoAwesomeOutlined, FlagOutlined, PollOutlined, AccountCircleOutlined, ApprovalOutlined, CollectionsOutlined } from '@mui/icons-material';
import { PermissionTypeEnum } from 'types/user-profile';

// constant
const icons = {
    ManageAccountsOutlined,
    BuildOutlined,
    LanguageOutlined,
    SettingsInputComponentOutlined,
    FactCheckOutlined,
    ApprovalOutlined,
    TableChartOutlined,
    DashboardOutlined,
    CampaignOutlined,
    CurrencyExchangeOutlined,
    SettingsOutlined,
    SettingsSuggestOutlined,
    PeopleAltOutlined,
    LocalOfferOutlined,
    WidgetsOutlined 
};

// ==============================|| WIDGET MENU ITEMS ||============================== //

const widget = {
    id: 'widget',
    // systemAdminOnly: true,
    // title: <FormattedMessage id="settings" />,
    type: 'group',
    children: [
        {
            id: 'agency_managet',
            title: <FormattedMessage id="Agency Managet" />,
            type: 'collapse',
            icon: BusinessOutlined,
            children:[
                 {
                    id: 'managerdashboard',
                    title: <FormattedMessage id="Media Dashboard" />,
                    type: 'item',
                    url: '/dashboard/managerdashboard',
                    icon: PollOutlined,
                    breadcrumbs: true,
                    requeredPermission: [PermissionTypeEnum.ManagementReports]
                // systemAdminOnly: true
                },
                {
                    id: 'media_dashboard2',
                    title: <FormattedMessage id="Media Dashboard 2" />,
                    type: 'item',
                    url: '/dashboard/mediaDashboard2',
                    icon: PollOutlined,
                    breadcrumbs: true,
                    requeredPermission: [PermissionTypeEnum.ManagementReports],
                    feature: 'rpt.media_dashboard2'
                },
                {
                    id: 'media_serve',
                    title: <FormattedMessage id="Media Serve Report" />,
                    type: 'item',
                    url: '/mediaServe/list',
                    icon: TrackChangesOutlined,
                    breadcrumbs: true,
                    requeredPermission:[PermissionTypeEnum.ManagementReports],
                },
                {
                    id: 'ai_usage',
                    title: <FormattedMessage id="AI Usage" />,
                    type: 'item',
                    url: '/ai_usage/list',
                    icon: AutoModeOutlined,
                    breadcrumbs: true,
                    // developerOnly: true,
                    requeredPermission:[PermissionTypeEnum.Admin],
                    feature: 'ai.usage-report'
                },
                 {
                    id: 'systemmonitoring',
                    title: <FormattedMessage id="Agency Status" />,
                    type: 'item',
                    url: '/systemMonitoring',
                    icon: FlagOutlined,
                    breadcrumbs: true,
                    requeredPermission: [PermissionTypeEnum.ManagementReports]
                // isLocked:true
                },
            ]
        }, 
        {
            id: 'accounts_managet',
            title: <FormattedMessage id="Accounts Managet" />,
            type: 'collapse',
            icon: PeopleOutlined,
            children:[
                {
                    id: 'accounts',
                    title: <FormattedMessage id="accounts" />,
                    type: 'item',
                    url: '/accounts/list',
                    icon: BusinessCenterOutlined,
                    breadcrumbs: true
                },
                {
                    id: 'reports',
                    title: <FormattedMessage id="Reports" />,
                    type: 'item',
                    url: '/performance/list',
                    icon: Insights,
                    breadcrumbs: true,
                    requeredPermission: [PermissionTypeEnum.OperationalReports]
                },
                {
                    id: 'creatives_report',
                    title: <FormattedMessage id="Creative Report" />,
                    type: 'item',
                    url: '/creatives/report',
                    icon: CollectionsOutlined,
                    breadcrumbs: true,
                    requeredPermission: [PermissionTypeEnum.OperationalReports],
                },
                {
                    id: 'billing',
                    title: <FormattedMessage id="Billing Report" />,
                    type: 'item',
                    url: '/billing/list',
                    icon: MonetizationOnOutlined,
                    breadcrumbs: true,
                    requeredPermission:[PermissionTypeEnum.OperationalReports],
                // systemAdminOnly: true,
                },
                {
                    id: 'client_confirm',
                    title: <FormattedMessage id="Client Confirmations" />,
                    type: 'item',
                    url: '/confirmations/list',
                    icon: icons.FactCheckOutlined,
                    breadcrumbs: true,
                    requeredPermission:[PermissionTypeEnum.OperationalReports],
                    feature: 'mx.approval'
                // systemAdminOnly: true,
                },
                {
                    id: 'ai_analytics',
                    title: <FormattedMessage id="ai analytics" />,
                    type: 'item',
                    url: '/ai_analytics',
                    icon: AutoAwesomeOutlined,
                    breadcrumbs: true,
                    // systemAdminOnly: true
                    // isLocked:true
                },
                {
                    id: 'systemmonitoring',
                    title: <FormattedMessage id="Agency Status" />,
                    type: 'item',
                    url: '/systemMonitoring',
                    icon: FlagOutlined,
                    breadcrumbs: true,
                    requeredPermission: [PermissionTypeEnum.OperationalReports],
                    hideFromPermission: [PermissionTypeEnum.ManagementReports]
                // isLocked:true
                },
            ]
        }, 
        {
            id: 'my_workspace',
            title: <FormattedMessage id="My Workspace" />,
            type: 'collapse',
            icon:PersonOutlineOutlined,
            children:[
                {
                    id: 'tasks',
                    title: <FormattedMessage id="Tasks" />,
                    type: 'item',
                    url: '/tasks/list',
                    icon: AssignmentTurnedInOutlined,
                    breadcrumbs: true,
                // requeredPermission:[PermissionTypeEnum.AccountCreateDelete],
                    // developerOnly: true,
                    feature: 'mx.approval'
                },
                {
                    id: 'pending_approvals',
                    title: <FormattedMessage id="Pending Approvals" />,
                    type: 'item',
                    url: '/pendingApprovals/list',
                    icon: VerifiedOutlined,
                    breadcrumbs: true,
                    requeredPermission:[PermissionTypeEnum.MediaPlanApprover],
                // developerOnly: true,
                feature: 'mx.approval'
                },
                 {
                    id: 'user_profile',
                    title: <FormattedMessage id="User Profile" />,
                    type: 'item',
                    url: '/user/account-profile/profile2',
                    icon: AccountCircleOutlined,
                    breadcrumbs: true,
                },
                 
            ]
        },
    //    {
    //         id: 'tools',
    //         title: <FormattedMessage id="Tools" />,
    //         type: 'collapse',
    //         icon: WorkspacesOutlined,
    //        // adminOnly: true,
    //         children: [
                
                
               
                
    //         ]},
        
        {
            id: 'settings',
            title: <FormattedMessage id="Settings" />,
            type: 'collapse',
            icon: icons.SettingsOutlined,
           // adminOnly: true,
            children: [
                {
                    id: 'system_configurations',
                    title: <FormattedMessage id="System Configurations" />,
                    type: 'item',
                    url: '/agentSettings/configurations',
                    icon: DisplaySettingsOutlined,
                    requeredPermission:[PermissionTypeEnum.GeneralSettings]
                },
                {
                    id: 'agent_connectors',
                    title: <FormattedMessage id="agent connectors" />,
                    type: 'item',
                    url: '/agentSettings/connectors/list',
                    icon: icons.SettingsInputComponentOutlined,
                    requeredPermission:[PermissionTypeEnum.GeneralSettings]
                },
                    {
                    id: 'accounts_channels',
                    title: <FormattedMessage id="Media Channels" />,
                    type: 'item',
                    url: '/agentSettings/channelTypes/list',
                    icon: icons.CampaignOutlined,
                    requeredPermission:[PermissionTypeEnum.Admin],
                    // developerOnly: true,
                   // feature: 'st.accounts_channels'
                },
                {
                    id: 'ai_settings',
                    title: <FormattedMessage id="ai settings" />,
                    type: 'item',
                    url: '/agentSettings/agentAI/settings',
                    icon: icons.SettingsSuggestOutlined,
                    requeredPermission:[PermissionTypeEnum.GeneralSettings]
                },
                {
                    id: 'media_plan_approvals',
                    title: <FormattedMessage id="Media Plan Approvals" />,
                    type: 'item',
                    url: '/agentSettings/mediaPlanApprovals/list',
                    icon: icons.ApprovalOutlined,
                    requeredPermission:[PermissionTypeEnum.GeneralSettings],
                    // developerOnly: true,
                    feature: 'mx.approval'
                },
                {
                    
                    id: 'material_numbers',
                    title: <FormattedMessage id="Material Numbers" />,
                    type: 'item',
                    url: '/agentSettings/materialNumbers/list',
                    icon: icons.LocalOfferOutlined,
                    requeredPermission:[PermissionTypeEnum.GeneralSettings],
                    // systemAdminOnly: true,
                },
                {
                    id: 'custom_columns',
                    title: <FormattedMessage id="custom columns" />,
                    type: 'item',
                    url: '/customColumns/list',
                    icon: icons.WidgetsOutlined,
                    requeredPermission:[PermissionTypeEnum.GeneralSettings]
                },
                {
                    id: 'mix_templates',
                    title: <FormattedMessage id="Templates" />,
                    type: 'item',
                    url: '/templates/list',
                    icon: icons.DashboardOutlined,
                    requeredPermission:[PermissionTypeEnum.GeneralSettings]
                },
                {
                    id: 'users',
                    title: <FormattedMessage id="users" />,
                    type: 'item',
                    url: '/Users/list',
                    icon: icons.PeopleAltOutlined,
                    requeredPermission:[PermissionTypeEnum.GeneralSettings],
                    breadcrumbs: true
                }]
            },
        {
            id: 'global_settings',
            title: <FormattedMessage id="Global Settings" />,
            type: 'collapse',
            icon: icons.LanguageOutlined,
            systemAdminOnly: true,
            children: [
                {
                    id: 'global_channels',
                    title: <FormattedMessage id="Channel Types" />,
                    type: 'item',
                    url: '/globalSettings/channelTypes/list',
                    icon: icons.CampaignOutlined,
                  //  systemAdminOnly: true
                },
                {
                    id: 'global_connectors',
                    title: <FormattedMessage id="global connectors" />,
                    type: 'item',
                    url: '/globalSettings/connectors/list',
                    icon: icons.SettingsInputComponentOutlined,
                    
                },
                {
                    id: 'global_ai_settings',
                    title: <FormattedMessage id="global ai settings" />,
                    type: 'item',
                    url: '/globalSettings/globalAI/settings',
                    icon: icons.SettingsSuggestOutlined,
                    
                }
            ]
        },
        
        
       
    ]
};

export default widget;
